function e(e){return e===``||e===void 0?!0:Array.isArray(e)?e.length===0:Object.keys(e).length===0}export{e as isEmpty};
//# sourceMappingURL=isEmpty-B6r3tkJ8.js.map